<template>
  <div>
    <Modal :title="title" :value="value" @on-visible-change="change_s" width="580">
      <div style="margin: 8px 16px">
        添加人员：
        <Select 
          v-model="search" 
          style="width:360px"
          filterable 
          multiple
          placeholder="请输入需要添加的用户姓名"
          @on-change="(val)=>{newMenber=val}">
          <Option v-for="item in list" :value="item.id" :key="item.id">{{ item.fullName }}</Option>
        </Select>
      </div>
      <CheckboxGroup v-model="selectRoles">
        <span v-for="role in role_list" :key="role.id || role.abpUserId">
          <Checkbox :label="role.id || role.abpUserId" class="checkbox-item" :class="{'checked-item': selectRoles.indexOf(role.name) !== -1}">
            <span :class="{highLight: search.indexOf(role.abpUserId)!==-1 || search.indexOf(role.id)!==-1}">
              {{role.fullName}}
            </span>
          </Checkbox>
        </span>
      </CheckboxGroup>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button @click="editRole" type="primary">确定</Button>
      </div>
      <!-- <Spin size="large" fix v-if="spinShow"></Spin> -->
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/userAjax'
import userAjax from '@/lib/userAjax'
import { setTimeout } from 'timers'

export default {
  props: {
    title: String,
    value: {
      type: Boolean,
      default: false
    },
    role_list: {
      type: Array
    },
    type_name: {
      type: String
    },
    currentRole: {
      type: Object
    }
  },
  data(){
    return {
      role_id: '',
      selectRoles: [],
      ed_data: {},
      list: [],
      search: [],
      newMenber: []
    }
  },
  watch: {
    role_list(val) {
      this.search = []
      setTimeout(() => {
        this.selectRoles = val.map(item=>{
          return item.id || item.abpUserId
        })
      }, 0)
    },
    currentRole(val) {
      setTimeout(() => {
        this.role_id = val.id
      }, 50)
    }
  },
  mounted() {
    this.list = []
    // 获取所有用户
    ajax.get('/api/services/app/User/GetAll?MaxResultCount=500').then(res => {
      this.list = res.data.result.items
    })
  },
  methods: {
    async editRole(){
      let update = []
      update = this.selectRoles.concat(this.newMenber)
      if (this.title === '角色人员') {
        // 批量修改角色关联用户
        userAjax.post('/api/services/app/User/BatchUpdateRoleUsers', {
          roleId: this.role_id,
          userids: update
        }).then(res => {
          if(res.data.success){
            this.$Message.success("修改成功")
          }else{
            this.$Message.success("修改失败")
          }
        })
        this.$emit('save-success')
      } else if (this.title === '流程角色人员') {
        userAjax.post(`/api/services/app/BaseUserEmpRole/BatchUpdateEmpRoleByAbpUserIds?role_id=${this.role_id}`, update).then(async() => {
          this.$Message.success("修改成功")
          this.$emit('save-success')
        })
      }
    },
    cancel(){
      this.$emit('save-success')
    },
    change_s(val){
      if(!val){
        this.$emit('save-success')
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ivu-modal-body {
  min-height: 218px;
  max-height: 400px;
  overflow: auto;
}
// 修改checkbox样式
.checkbox-item {
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px;
  &:hover {
    border-color: #2d8cf0;
  }
}
.checked-item {
  border-color: #2d8cf0;
}
.highLight {
  background-color: #FFFF66;
}
</style>
